import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UserInfo } from '@epicuro-next/models/engagement';

@Component({
  selector: 'epc-list-user',
  templateUrl: './list-user.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ListUserComponent {
  @Input()
  public user: UserInfo;

  @Input()
  public date: Date;

  public dateFormat = 'MMM d, yyyy';
}
